import { Carrier } from '../../../types/carrier';
import Method, { MethodProps } from '../Method';
import { HubbedLocation } from '../../../types/hubbed';

export const HubbedDropOffItem: MethodProps = {
  title: 'Hubbed Drop Off',
  cost: '',
  description:
    'Book and drop your parcel off at a convenient Hubbed location near you',
  dropoff: true,
};

const HubbedCarrier: Carrier = {
  carrier_type: 'Hubbed',
  carrier_name: 'Hubbed',
  service_level: 'standard',
  dropoff: true,
};

class HubbedMethod extends Method {
  private hubbedLocation: HubbedLocation | undefined;

  constructor(position: number, carrier?: Carrier) {
    super(HubbedDropOffItem, position, carrier || HubbedCarrier);
  }

  isHubbed() {
    return true;
  }

  setHubbedLocation(hubbedLocation: HubbedLocation | undefined) {
    this.hubbedLocation = hubbedLocation;
  }

  getHubbedLocation() {
    return this.hubbedLocation!;
  }
}

export default HubbedMethod;
